import styled from 'styled-components/macro';
import { Link } from '../../../../../shared-styles';

export const NoteSectionElement = styled.span`
  font-size: ${(props) => props.theme.typography.sizes.small};
`;

export const SeeMoreLessLink = styled.span`
  ${Link}
  margin-top: -16px;
  padding-left: ${(props) => props.theme.spacing(5)};
  background-color: transparent;
`;
